import { TexteSeoVisuelBas } from '@components/texte-seo-visuel-bas/models';
import { imageMock, textSeoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const texteSeoVisuelBasMock: Block<TexteSeoVisuelBas> = {
  type: 'texte-seo-visuel-bas',
  data: {
    title: {
      text: `Made in \\\\[[chez moi]]`,
      as: 'span',
    },
    image: imageMock,
    textSeo: textSeoMock(),
  },
};
